<template>
  <b-modal
    id="subcontractors-modal"
    size="lg"
    ref="subcontractors_modal"
    title="Edytuj podwykonawców na budowie"
    @hidden="onClose"
    @show="onShow"
  >
    <form id="constructionSubcontractors" @submit.prevent="onSubmit">
      <ConstructionSubcontractorsForm
        :subcontractors="this.selected"
        v-on:onchange="this.handlePositionChange"
      />
    </form>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="constructionSubcontractors">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>


<script>
import { mapActions } from "vuex";
import ConstructionSubcontractorsForm from "@/components/construction/ConstructionSubcontractorsForm";

export default {
  name: "ConstructionModalSubcontractorsForm",
  components: { ConstructionSubcontractorsForm },
  props: {
    construction_id: { type: Number },
    subcontractors: { type: Array }
  },
  data() {
    return {
      selected: []
    };
  },
  methods: {
    ...mapActions("construction", ["updateSubcontractors"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      //todo: skopiować tabele subcontractor by odciac od vuexa
      this.$_.each(this.subcontractors, item => {
        this.selected.push({
          position_id: item.position_id,
          user_id: item.user_id,
          firstname: item.firstname,
          lastname: item.lastname,
          phone: item.phone
        });
      });
    },
    onClose() {
      this.selected = [];
    },
    onSubmit() {
      this.$Progress.start();
      this.updateSubcontractors({
        construction_id: this.construction_id,
        subcontractors_raw: this.selected
      }).then(() => {
        this.$nextTick(() => {
          this.$bvModal.hide("subcontractors-modal");
        });
      });
    },
    handlePositionChange(newList) {
      this.selected = newList;
    }
  }
};
</script>